document.addEventListener( 'DOMContentLoaded', function() {
    let mm = gsap.matchMedia();
    
    // 743px 以下の画面サイズでスライダーを初期化
    mm.add("(max-width: 743px)", () => {
        var splidePick = new Splide( '.pickup-splide',{
            pagination: true, 
            type   : 'loop',
            gap: 0,
            focus  : 0,
            perPage: 1,
            perMove: 1,
            classes: {
                arrows: 'splide__arrows i-article-arrows splide-pickup-arrows',
                arrow : 'splide__arrow i-article-arrow splide-pickup-arrow',
                prev  : 'splide__arrow--prev i-article-prev splide-pickup-arrows-prev',
                next  : 'splide__arrow--next i-article-next splide-pickup-arrows-next',
            },
        });
        splidePick.mount();
    });
    
    // 744px 以上の画面サイズでの処理
    mm.add("(min-width: 744px)", () => {
       
    });
  });
  